export const isEmpty = (object: string | number | Date | null) => {
  if (object === undefined || object === null || object.toString().trim() === '') {
    return true;
  }
  return false;
};
